"use strict";

exports.__esModule = true;
var _DeviceList = require("./DeviceList");
Object.keys(_DeviceList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceList[key]) return;
  exports[key] = _DeviceList[key];
});